module.exports = "<footer class=\"footer\">\r\n  <div class=\"sign\">\r\n    <strong>Copyright © 2011-2018 Hong Kong. multiboxx.com All rights reserved Privacy Policy Terms & Conditions\r\n      </strong>\r\n  </div>\r\n</footer>"


//////////////////
// WEBPACK FOOTER
// ./src/app/footer/footer.component.html
// module id = ./src/app/footer/footer.component.html
// module chunks = main